import React, { useState } from 'react';

const SoilTypeLegend = () => {
  const [isExpanded, setIsExpanded] = useState(false);

  const legendStyle = {
    position: 'absolute',
    bottom: '10px',
    right: '10px',
    backgroundColor: 'white',
    padding: '10px',
    borderRadius: '5px',
    boxShadow: '0 2px 6px rgba(0, 0, 0, 0.3)',
    zIndex: 1000, // 맵 위에 보이도록 z-index 설정
  };

  const legendItemStyle = {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '5px',
  };

  const colorBoxStyle = (color) => ({
    width: '20px',
    height: '20px',
    backgroundColor: color,
    marginRight: '10px',
  });

  const headerStyle = {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    cursor: 'pointer',
    marginBottom: isExpanded ? '10px' : '0',
  };

  return (
    <div style={legendStyle}>
      <div style={headerStyle} onClick={() => setIsExpanded(!isExpanded)}>
        <h4 style={{ fontWeight:'bold', margin: 0 }}>지반 분류</h4>
        <span style={{ marginLeft: '10px', fontSize: '14px' }}>{isExpanded ? '▼' : '▶'}</span>
      </div>
      {isExpanded && (
        <>
          <div style={legendItemStyle}>
            <div style={colorBoxStyle('#7f7f7f')}></div>
            <span>분류 불가 (회색)</span>
          </div>
          <div style={legendItemStyle}>
            <div style={colorBoxStyle('#1f77b4')}></div>
            <span>S1 (파란색)</span>
          </div>
          <div style={legendItemStyle}>
            <div style={colorBoxStyle('#2ca02c')}></div>
            <span>S2 (초록색)</span>
          </div>
          <div style={legendItemStyle}>
            <div style={colorBoxStyle('#ff7f0e')}></div>
            <span>S3 (주황색)</span>
          </div>
          <div style={legendItemStyle}>
            <div style={colorBoxStyle('#d62728')}></div>
            <span>S4 (빨간색)</span>
          </div>
          <div style={legendItemStyle}>
            <div style={colorBoxStyle('#9467bd')}></div>
            <span>S5 (보라색)</span>
          </div>
          <div style={{fontSize:"12px"}}> 임시 분류일 경우 노란색 테두리</div>
        </>
      )}
    </div>
  );
};

export default SoilTypeLegend;